import React from 'react';
import { useDispatch } from 'react-redux';
import { ConfigurationAppT } from '.';
import "./globall.scss";
//@ts-ignore
import { MainPage } from './page/MainPage';
//@ts-ignore
import { setInitializationThreeKit } from './store/actions/setting';

export const AppConfig = ({ ...props }: ConfigurationAppT) => {
  const { initializationThreekit } = props;
  const dispatch = useDispatch();

  dispatch(setInitializationThreeKit({ initializationThreekit }))

  return (
    <MainPage />
  );
}
